// user 模块相关的 mutations 类型
export const USER_MODULE = 'user/'

export const UPDATE_TOKEN = 'update_token'
export const UPDATE_MENU = 'update_menu'

// tagsView 模块相关的 mutations 类型
export const TAGS_MODULE  = 'tagsView/'

export const ADD_VISITED_VIEW = 'add_visited_view'
export const ADD_CACHED_VIEW = 'add_cached_view'
export const DEL_VISITED_VIEW = 'del_visited_view'
export const DEL_CACHED_VIEW = 'del_cached_view'
export const DEL_OTHER_VISITED_VIEWS = 'del_other_visited_views'
export const DEL_OTHER_CACHED_VIEWS = 'del_other_cached_views'
export const DEL_ALL_VISITED_VIEWS = 'del_all_visited_views'
export const DEL_ALL_CACHED_VIEWS = 'del_all_cached_views'
export const UPDATE_VISITED_VIEWS = 'update_visited_views'

// entity 模块相关的 mutations 类型
export const ENTITY_MODULE = 'entity/'

export const UPDATE_ENTITY = 'update_entity'
